<template>

  <div class="oauth_container">

    <div class="waiter" v-show="pleaseWait">
      <h1>Linking your account</h1>
      <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>

    <div class="social-error" v-if="signInError">
      <span>{{signInErrorMessage}}</span>
      <br><br>
      <router-link to="/" class="button">RETRY</router-link>
      <p>
      </p>
    </div>

    <div id="tcontainer"></div>

  </div>
    
</template>

<script>
import { authService } from '../services/auth';

export default {
  name: 'OauthSignin',

  data: function() {
    return {
      signInError : false,
      signInErrorMessage : "",

      pleaseWait : true
    }
  },

  computed: {
      globalCurrency: function () {
          return this.$store.currency;
      },
    },

  async mounted() {

    // Ad Cash tracker
    const cid = this.$cookies.get("cid");
    if (cid && cid !== '') {
      const tUrl = `https://www.pixelhere.com/et/event.php?advertiser=165708&cid=${cid}&id=89b98e`
      document.getElementById("tcontainer").innerHTML = `<img src="${tUrl}" style="display:none" />`
    }

    // this.$gtag.event('oauth-signin', {
    //     'event_category': 'Auth',
    //     'event_label': 'Social Signin confirmation Page',
    //     'value': cid
    //   })

    const currentSession =    await authService.getUserSession().catch((err) => console.log(err));
    const currentUser =  await authService.getCurrentUser().catch((err) => console.log(err));
    
    if (currentSession == null || currentUser == null) {
      this.signInError = true
      this.signInErrorMessage = "Sorry, we could not sign you in. Please retry or choose another sign in method."
      this.pleaseWait = false
    }
    else {

      // ok, try to create/map user
      try {
        
        const provider = currentSession?.idToken.payload.identities[0]?.providerName
        const firstName = currentSession?.idToken.payload.given_name ?? ""
        const lastName = currentSession?.idToken.payload.family_name ?? ""
        let profilePicture = currentSession?.idToken.payload.picture ?? ""
        
        // try to get FB picture URL
        if ((provider+'').toLowerCase() === "facebook") {
          try {
            profilePicture = JSON.parse(profilePicture).data.url
          } catch (error) {
            profilePicture = ""
          }
        }
        
        // try to get FB picture URL
        if ((provider+'').toLowerCase() === "facebook") {
          try {
            profilePicture = JSON.parse(profilePicture).data.url
          } catch (error) {
            profilePicture = ""
          }
        }

        const usr = await authService.mapUser("", provider, "", true, firstName, lastName, profilePicture)
        
        this.$router.push("/register")
        
      } catch (error) {
        
        // console.log(error)
        this.signInError = true
        this.signInErrorMessage = "There was an error while linking your account. Please try again or choose another provider."

      }
      finally {
        this.pleaseWait = false
      }

    }

  }

}
</script>


<style lang="scss" scoped>
.oauth_container {
  min-height: 50vh;
}
</style>